import React from "react";
import { Card, Text, Badge, Group, Avatar, Stack } from "@mantine/core";
import { CheckIcon } from "@mantine/core";
import { IconProgress } from "@tabler/icons-react";

type StatusType = "Working" | "Break" | "Offline";

type StatusCardData = {
  name: string;
  status: StatusType;
  time: string;
  icon?: React.ElementType;
};

const statusColorMap: Record<StatusType, string> = {
  Working: "green",
  Break: "yellow",
  Offline: "red",
};

export default function StatusCard() {
  const data: StatusCardData[] = [
    {
      name: "Staus",
      status: "Working",
      time: "4 hours today",
      icon: CheckIcon,
    },
    {
      name: "Created Name",
      status: "Break",
      time: "1 hour",
      icon: CheckIcon,
    },
    {
      name: "Priority",
      status: "Offline",
      time: "0 hours",
      icon: CheckIcon,
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
      {data.map((item, index) => (
        <Card
          key={item.name}
          shadow="sm"
          radius="md"
          withBorder
          style={{ flex: 1, minWidth: "200px" }}
        >
          <Group position="apart" mb="xs">
            <Group>
              <div
                style={{
                  backgroundColor:
                    item.status === "Working" ? "#e0f7fa" : "#fce4ec",
                  //   width: "50px",
                  //   height: "40px",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconProgress stroke={2} />
              </div>
              <div>
                <Text fw={200}>{item.name}</Text>
                <Badge color={statusColorMap[item.status]} variant="light">
                  {item.status}
                </Badge>
              </div>
            </Group>
          </Group>
        </Card>
      ))}
    </div>
  );
}
